import axios from "axios";

import Token from "../../utilities/jwt/Token.js";

export default class NaturezaJuridicaService extends Token {
  findAll() {
    return axios({
      method: "get",
      url: this.api_url + "natureza-juridica",
      withCredentials: true,
      headers: {
        Authorization: "Bearer " + this.token(),
      },
    }).then((res) => res.data);
  }

  create(natureza) {
    return axios({
      method: "post",
      url: this.api_url + "natureza-juridica",
      withCredentials: true,
      data: natureza,
      headers: {
        Authorization: "Bearer " + this.token(),
      },
    });
  }
  update(natureza) {
    return axios({
      method: 'put',
      url: this.api_url + 'natureza-juridica/' + natureza.id,
      withCredentials: true,
      data: natureza,
      headers: {
        'Authorization': 'Bearer ' + this.token(),
      }
    });

  }

  delete(id) {
    return axios({
      method: 'delete',
      url: this.api_url + 'natureza-juridica/' + id,
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + this.token(),
      }
    });

  }
}
